import React, {Component} from 'react'
import {connect} from 'react-redux'
import InfoTab from './infoTab'
import Resources from '../../../data/services/resources'
import {showGlobalModal} from '../../../data/actions/ui'
import LocalStorage from '../../../util/localStorage'
import {getCountTaskResource} from '../../../data/actions/taskResource'
import Tippy from '@tippyjs/react'
import {Field, FieldsManager} from '../../../data/services/fields'
import {getInfoResource} from '../../../data/actions/infoResource'
import TruckTypeTab from './truck-type-tab'
import {
    CREATE_PERM, DEFAULT_METADATA_SELECT_SEARCH_QUERY,
    DELETE_PERM,
    READ_PERM,
    REFERENCE_TYPE_TRUCK,
    SECTIONS_VISIBILITY,
    UPDATE_PERM
} from '../../../util/util-constants'
import {
    checkPerm,
    classNames,
    getDocumentTypesFor,
    getProp,
    getTabSettings, resourceIsCreated,
    resourceIsUpdated
} from '../../../common/util/util-helpers'
import Page from "../../../common/components/layout/layout-components/page";
import GoBackButton from "../../../common/components/layout/layout-components/go-back-button";
import Layout from "../../../common/components/layout";
import NavResponsive from "../../../common/components/nav-responsive";
import MobileTabs from "../../../common/components/tabs-navigation/mobile-tabs";
import ResourceListTab from "../../../common/components/tabs/resource-list-tab";
import ExpiryItemsTab from "../../../common/components/tabs/expiry-items-tab";
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import ResourceTasksDialog from "../../../common/components/modal/tasksDialogs/resourceTasksDialog";
import LoadsTab from "../../../common/components/modal/load-tab";
import LocationsTab from "../../../common/components/modal/locations-tab";
import ModalDefault from "../../../common/components/modal/modal-default";
import ServicesTab from "./services-tab";
import ResourceTableTags from "../../../common/components/resource-table/table-components/resource-table-tags";
import {LoaderSmall} from "../../../common/components/loader";
import TrucksTableBadge from "../trucks-view/trucks-table-badge";
import TruckSettlementTab from "./truck-settlement-tab";
import DocumentsUpdateTab from "../../../common/components/tabs/documents-tab/update-documents";
import TruckPayrollSetupTab from "./truck-payroll-setup-tab";
import UpcomingMaintenanceTab from "../maintenance-view/upcomingMaintenanceTab";
import SubmissionsTab from "../vehicle-inspections-view/submissions-tab";
import {DEFAULT_QUERY_LIMIT} from "../../../common/util/util-consts";
import Tooltip from "../../../common/components/tooltip";
import {InformationCircleIcon} from "@heroicons/react/24/outline";
import InfoParagraph from "../../../common/components/info-paragraph";
import Button from "../../../common/components/button";
import {createResource, updateResource} from "../../../data/actions/resource";
import ModalSaveResource from "../../../common/components/modal/modal-save-resource";

class TruckView extends Component {

    constructor(props) {
        super(props)

        let tabsSettings = getTabSettings('Fleet', 'Trucks');

        const tabs = [
            {
                name: 'TrucksInfo',
                resource: Resources.TrucksInfo,
                current: true,
                visible: checkPerm(Resources.TrucksInfo, READ_PERM)
            },
            {
                name: 'TrucksSettlementSummary',
                resource: Resources.TrucksPayroll,
                current: false,
                visible: !!SECTIONS_VISIBILITY.hasTruckSettlementSummary && checkPerm(Resources.TrucksPayroll, READ_PERM)
            },
            {
                name: 'TrucksPayrollSetup',
                resource: Resources.TrucksSettlements,
                current: false,
                visible: !!SECTIONS_VISIBILITY.hasTruckPayrollSetup && checkPerm(Resources.TrucksPayroll, READ_PERM)
            },
            {
                name: 'TruckProfitability',
                resource: Resources.TruckProfitability,
                current: false,
                visible: checkPerm(Resources.TruckProfitability, READ_PERM)
            },
            {
                name: 'Upcoming Maintenance',
                resource: Resources.WorkOrderUpcomingMaintenance,
                current: false,
                visible: checkPerm(Resources.WorkOrderUpcomingMaintenance, READ_PERM)
            },
            {
                name: 'TruckInspections',
                resource: Resources.DvirSubmissions,
                current: false,
                visible: checkPerm(Resources.DvirSubmissions, READ_PERM)
            },
            {
                name: 'TrucksPermits',
                resource: Resources.TrucksPermits,
                current: false,
                visible: checkPerm(Resources.TrucksPermits, READ_PERM)
            },
            // {
            //     name: 'TrucksMileage',
            //     resource: Resources.TrucksMileage,
            //     current: false,
            //     visible: checkPerm(Resources.TrucksMileage, READ_PERM)
            // },

            {
                name: 'TrucksType',
                resource: Resources.TrucksType,
                current: false,
                visible: checkPerm(Resources.TrucksType, READ_PERM)
            },
            {
                name: 'RestrictedArea',
                resource: Resources.TrucksCanGo,
                current: false,
                visible: checkPerm(Resources.TrucksCanGo, READ_PERM)
            },
            {
                name: 'TrucksLocations',
                resource: Resources.TrucksLocations,
                current: false,
                visible: checkPerm(Resources.TrucksLocations, READ_PERM)
            },
            {
                name: 'TrucksLoads',
                resource: Resources.TrucksLoads,
                current: false,
                visible: checkPerm(Resources.TrucksLoads, READ_PERM)
            },
            {
                name: 'TruckServices',
                resource: Resources.TruckServices,
                current: false,
                visible: checkPerm(Resources.TruckServices, READ_PERM)
            },
            {
                name: 'ExpiryItems',
                resource: Resources.TrucksExpiry,
                current: false,
                visible: checkPerm(Resources.TrucksExpiry, READ_PERM)
            },
            {
                name: 'TruckDocuments',
                resource: Resources.TruckDocuments,
                current: false,
                visible: checkPerm(Resources.TruckDocuments, READ_PERM)
            }
        ].map(it => {
            if (!!tabsSettings && it.visible !== false) {
                it.visible = tabsSettings?.[it.name]?.isVisible !== false;
            }

            return it;
        })

        const profitabilityTabs = [
            {
                name: 'RecurringCosts',
                current: true,
                resource: 'RecurringCosts',
                visible: checkPerm(Resources.TruckProfitability, READ_PERM)
            },
            {
                name: 'Adjustments',
                current: false,
                resource: 'Adjustments',
                visible: checkPerm(Resources.TruckProfitability, READ_PERM)
            }]
        this.state = {
            // Tabs
            tabs: tabs,
            selectedTab: Resources.TrucksInfo,
            profitabilityTabs: profitabilityTabs,
            selectedProfitabilityTab: 'RecurringCosts',

            // Modals
            resourceTaskModalOpen: false,

            canSwapTabs: true,
            applyTemplateOpen: false
        }
    }


    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        if (this.getID()) {
            this.handleCheckIfRedirected()
            this.fetchTaskResourceCount()
            this.fetchData()
        }
    }

    componentDidUpdate = (prevProps) => {
        if (resourceIsUpdated(this.props.dialogResource, prevProps.dialogResource) && this.props.dialogResource.resource === Resources.TrucksColor) {
            this.fetchData();
        }

        if (resourceIsUpdated(this.props.resource, prevProps.resource) && this.props.resource.resource === Resources.TruckRetire) {
            this.fetchData();
        }

        if (this.props.resource !== prevProps.resource && resourceIsCreated(this.props.resource) && this.props.resource.resource === Resources.TruckServices) {
            this.fetchData();
        }
    }

    /** Data events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getInfoResource({
            user: LocalStorage.get('user'),
            resource: Resources.TrucksInfo,
            query: {
                id: this.getID()
            }
        }))
    }

    fetchTaskResourceCount = () => {
        this.props.dispatch(getCountTaskResource({
            user: LocalStorage.get('user'),
            resource: Resources.TaskResourceCount,
            query: {param: window.location.pathname}
        }))
    }

    /** UI events
     ================================================================= */
    handleTabChange = (resource) => {
        if (resource === this.state.selectedTab) {
            return false
        }

        if (!this.state.canSwapTabs) {
            this.setState({
                confirmModalOpen: true,
                reserveTab: resource
            })
        } else {
            this.tabChange(resource)
        }
    }

    tabChange = (resource) => {
        this.props.history.push('?tab=' + resource)
        this.setState({
            confirmModalOpen: false,
            isDirty: false,
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
            selectedTab: resource
        })
    }
    handleProfitabilityTabChange = (resource) => {
        if (resource === this.state.selectedProfitabilityTab) {
            return false
        }

        this.setState({
            selectedProfitabilityTab: resource,
            profitabilityTabs: this.state.profitabilityTabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
        });
        }

    handleCreateNewResourceTask = () => {
        this.props.dispatch(showGlobalModal('createTaskDialog', {taskResource: this.props.match.url}))
    }

    handleToggleResourceTasks = () => {
        this.setState({
            resourceTaskModalOpen: !this.state.resourceTaskModalOpen
        })
    }

    handleCheckIfRedirected = () => {
        const query = new URLSearchParams(this.props.location.search)
        const tab = query.get('tab')
        if (tab) {
            this.handleTabChange(tab)
        }
    }

    handleToggleApplyTemplateModal = () => {
        this.setState({applyTemplateOpen:!this.state.applyTemplateOpen})
    }

    getApplyFields = () => {
        return {
            TruckID: new Field('TruckID', this.getID(), ['empty'], true, 'hidden'),
            TruckProfitTemplateID: new Field('TruckProfitTemplateID', '', ['empty'], false, 'select-search', {addContainerClass: "col-span-3"})
        }
    }
    /** Helpers
     ================================================================= */
    canSwapTabsHandler = (canSwapTabs = false) => {
        this.setState({canSwapTabs: canSwapTabs})
    }

    getMinDate = (fields) => {
        return fields.reduce((memo, item) => {
            if (item.name === 'StartDate') {
                memo = item.value
                return memo
            }

            return memo
        }, '');
    }

    getMaxDate = (fields) => {
        return fields.reduce((memo, item) => {
            if (item.name === 'EndDate') {
                memo = item.value
                return memo
            }

            return memo
        }, '');
    }

    getID = () => {
        return this.props.match.params.id
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, download} = this.props
        const TaskCount = getProp(this.props.taskResource, 'count.count', 0)
        const openTaskCountTwoDigits = TaskCount > 9;
        const infoData = getProp(this.props.info, 'data', {})
        const isInfoLoading = getProp(this.props.info, 'isLoading', true);
        const ColorTags = getProp(this.props.info, 'data.ColorTag', "")
        const truckNumber = getProp(infoData, 'TruckNumber', 'Truck')

        return (
            <Layout {...this.props}
                    hasFooter={this.state.selectedTab === Resources.TrucksInfo}
                    isDirty={!this.state.canSwapTabs}
                    customPageTitle={truckNumber || 'Truck'}>
                <Page>
                    <div className="mb-2 flex justify-between items-center">
                        <div className="flex items-center justify-center">
                            <GoBackButton
                                translate={this.props.translate}
                                history={this.props.history}
                                path={'/trucks'}
                            />

                            <h1 className={'mr-5 text-3xl ml-2'}>
                                {translate('text.truck')}
                                <span className="text-tm-gray-500"> - {infoData.TruckNumber}
                                    {infoData.ArchivedDate && (
                                        <Tippy content={<span>Archived</span>}>
                                            <i className="iconsminds-delete-file"/>
                                        </Tippy>
                                    )}
                                </span>
                            </h1>

                            {ColorTags && (
                                <div>
                                    <ResourceTableTags data={ColorTags} addClass="py-1.5 mx-2"/>
                                </div>
                            )}

                            {!isInfoLoading ? (
                                <TrucksTableBadge
                                    onOutOfServiceClick={() => this.handleTabChange(Resources.TruckServices)}
                                    addClass={"h-8 items-center"}
                                    item={infoData}
                                    translate={this.props.translate}
                                />
                            ) : (
                                <LoaderSmall disableContainer={true}/>
                            )}
                        </div>

                        <div className="gap-2 flex flex-wrap items-center justify-end">
                            {checkPerm(Resources.Tasks, CREATE_PERM) && (
                                <div className="btn btn-outline mr-3"
                                     onClick={() => this.handleCreateNewResourceTask()}>{translate('btn.new_truck_task')}
                                </div>
                            )}

                            {checkPerm(Resources.Tasks, READ_PERM) && (
                                <div className="relative">
                                    <button
                                        className="btn btn-outline"
                                        disabled={!checkPerm(Resources.TaskResource, READ_PERM)}
                                        onClick={() => this.handleToggleResourceTasks()}>

                                        {TaskCount > 0 && (
                                            <span
                                                className={
                                                    classNames(
                                                        "absolute z-10 flex -top-2.5 -left-2",
                                                        openTaskCountTwoDigits ? "h-6 w-6" : "h-5 w-5"
                                                    )
                                                }
                                            >
                                                          <div
                                                              className="absolute z-10 font-bold inset-0 flex items-center justify-center text-primary-contrast">{[TaskCount]}</div>
                                                          <span
                                                              className="animate-ping absolute z-10 inline-flex h-full w-full rounded-full bg-primary opacity-25"></span>
                                                          <span
                                                              className={
                                                                  classNames(
                                                                      "relative inline-flex rounded-full bg-primary",
                                                                      openTaskCountTwoDigits ? "h-6 w-6" : "h-5 w-5"
                                                                  )
                                                              }
                                                          />
                                                    </span>
                                        )}
                                        {translate('btn.show_tasks')}
                                        {this.props.taskResource.isCountLoading && `(${translate('text.Loading...')})`}
                                        {!this.props.taskResource.isCountLoading && TaskCount === 0 && `(${TaskCount})`}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="hidden sm:block">
                        <NavResponsive
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    <div className="block sm:hidden">
                        <MobileTabs
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    {this.state.selectedTab === Resources.TrucksInfo && (
                        <InfoTab
                            canSwapTabsHandler={this.canSwapTabsHandler}
                            setActiveTab={this.handleTabChange}
                            {...this.props}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrucksPayroll && SECTIONS_VISIBILITY.hasTruckSettlementSummary && (
                        <TruckSettlementTab
                            dispatch={this.props.dispatch}
                            TruckID={this.props.match.params.id}
                            resource={this.props.resource}
                            secondResource={this.props.secondResource}
                            thirdResource={this.props.thirdResource}
                            info={this.props.info}
                            translate={this.props.translate}
                            location={this.props.location}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrucksSettlements && SECTIONS_VISIBILITY.hasTruckPayrollSetup && (
                        <TruckPayrollSetupTab
                            TruckID={this.props.match.params.id}
                            setIsStateDirty={(isDirty) => this.canSwapTabsHandler(!isDirty)}
                            translate={translate}
                        />
                    )}

                    {this.state.selectedTab === Resources.WorkOrderUpcomingMaintenance && (
                        <UpcomingMaintenanceTab
                            TruckID={this.getID()}
                            {...this.props}/>
                    )}

                    {this.state.selectedTab === Resources.DvirSubmissions && (
                        <SubmissionsTab
                            TruckID={this.getID()}
                            translate={this.props.translate}
                        />
                    )}

                    {this.state.selectedTab === Resources.TruckDocuments && (
                        <DocumentsUpdateTab
                            id={this.getID()}
                            dispatch={this.props.dispatch}
                            translate={this.props.translate}
                            resource={this.props.resource}
                            thirdResource={this.props.thirdResource}
                            pagePath={"/trucks/info/documents"}

                            sortBy={'Description'}
                            primaryKey={'TruckDocumentID'}

                            download={download}
                            resourceName={Resources.TruckDocuments}

                            documentUpdateFields={checkPerm(Resources.TruckDocuments, UPDATE_PERM) && {
                                DocumentTypeID: new Field("DocumentTypeID", '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}, {
                                    values: getDocumentTypesFor("IsFleetDocument")
                                }),
                                ExpiryDate: new Field("ExpiryDate", '', [], false, 'date', {addContainerClass: 'col-span-full'}, {isClearable: true}),
                                Description: new Field("Description", '', [], false, 'textarea', {addContainerClass: 'col-span-full'}),
                            }}

                            documentTypes={getDocumentTypesFor("IsFleetDocument")}
                            searchFields={{
                                query: new Field('query', '', [], false, 'search', {
                                    containerClass: 'col-md-4'
                                }),
                                DocumentTypeID: new Field('DocumentTypeID', '', [], false, 'select', {
                                    containerClass: 'col-md-4'
                                }, {
                                    all: true,
                                    values: getDocumentTypesFor("IsFleetDocument")
                                }),
                                DocumentExtension: new Field('DocumentExtension', '', [], false, 'select', {
                                    containerClass: 'col-md-4'
                                }, {
                                    all: true
                                }),
                            }}
                            readOnly={!checkPerm(Resources.TruckDocuments, CREATE_PERM)}
                            disableDelete={!checkPerm(Resources.TruckDocuments, DELETE_PERM)}
                        />
                    )}
                    {this.state.selectedTab === Resources.TrucksPermits && (
                        <ResourceListTab
                            id={this.getID()}
                            tabKey={'TrucksPermits'}
                            dispatch={this.props.dispatch}
                            translate={this.props.translate}
                            resource={this.props.resource}
                            disableEdit={!checkPerm(Resources.TrucksPermits, UPDATE_PERM)}
                            disableDelete={!checkPerm(Resources.TrucksPermits, DELETE_PERM)}
                            dialogTitle={"Permits"}
                            hideTitle={true}

                            sortBy={'TruckPermitID'}
                            primaryKey={'TruckPermitItemID'}
                            resourceName={Resources.TrucksPermits}
                            fields={() => {return {
                                TruckPermitID: new Field('TruckPermitID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
                                PermitNumber: new Field('PermitNumber', '', [], false, 'text', {
                                    addContainerClass: 'col-span-full'
                                }),
                                StartDate: new Field('StartDate', '', ['empty'], false, 'date', {
                                    maxDate: this.getMaxDate,
                                    addContainerClass: 'col-span-full'
                                }),
                                EndDate: new Field('EndDate', '', [], false, 'date', {
                                    minDate: this.getMinDate,
                                    addContainerClass: 'col-span-full'
                                }),
                                Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: 'col-span-full'}),
                            }}}
                            searchFields={{
                                query: new Field('query', '', [''], false, 'search', {
                                    containerClass: 'col-md-4'
                                }),
                                limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {
                                    containerClass: 'col-md-4',
                                    hideLabel: true
                                })
                            }}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrucksType && (
                        <TruckTypeTab
                            id={this.getID()}
                            dispatch={this.props.dispatch}
                            translate={this.props.translate}
                            resource={this.props.resource}

                            sortBy={'TruckTypeID'}
                            primaryKey={'TruckTypeItemID'}
                            resourceName={Resources.TrucksType}

                            fields={{
                                TruckTypeID: new Field('TruckTypeID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
                                Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: 'col-span-full'}),
                            }}
                            searchFields={{
                                query: new Field('query', '', [''], false, 'search', {
                                    containerClass: 'col-md-4'
                                })
                            }}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrucksCanGo && (
                        <ResourceListTab
                            tabKey={'TrucksCanGo'}
                            id={this.getID()}
                            dispatch={this.props.dispatch}
                            translate={this.props.translate}
                            resource={this.props.resource}
                            dialogTitle={"Restricted area"}
                            hideTitle={true}

                            sortBy={'TruckCanGoID'}
                            primaryKey={'TruckCanGoItemID'}
                            resourceName={Resources.TrucksCanGo}
                            fields={() => {return {
                                TruckCanGoID: new Field('TruckCanGoID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
                                Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: 'col-span-full'}),
                            }}}
                            searchFields={{
                                query: new Field('query', '', [''], false, 'search', {}),
                                limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true})
                            }}
                        />
                    )}

                    {this.state.selectedTab === Resources.TruckProfitability && (
                        <>
                            <div className="hidden sm:block mb-4">
                                <NavResponsive
                                    tabs={this.state.profitabilityTabs}
                                    onTabChange={this.handleProfitabilityTabChange}
                                    translate={translate}
                                />
                            </div>

                            <div className="block sm:hidden">
                                <MobileTabs
                                    tabs={this.state.profitabilityTabs}
                                    onTabChange={this.handleProfitabilityTabChange}
                                    translate={translate}
                                />
                            </div>

                            {this.state.selectedProfitabilityTab === 'RecurringCosts' &&
                                (<div>
                                    <Button
                                        addClass="h-10 flex"
                                        onClick={() => this.handleToggleApplyTemplateModal()}
                                        hasPerm={checkPerm(Resources.TruckProfitabilityTemplateApply, CREATE_PERM)}
                                    >
                                        Apply template
                                    </Button>

                                    <ResourceListTab
                                    tabKey={'TruckProfitability'}
                                    addClassTableCard={"mt-2"}
                                    id={this.getID()}
                                    dispatch={this.props.dispatch}
                                    translate={this.props.translate}
                                    resource={this.props.resource}
                                    dialogTitle={translate("dialog.title.RecurringCosts")}
                                    hideTitle={true}
                                    buttonLabel={"Add cost"}

                                    sortBy={'TruckProfitabilityID'}
                                    primaryKey={'TruckProfitabilityID'}
                                    resourceName={Resources.TruckProfitability}
                                    handleInputChange={(fields, name, value) => {
                                        if (name === "ProfitabilityType") {
                                            fields.Frequency.type = value == 1 ? 'select' : 'hidden'
                                            fields.Frequency.validate = value == 1 ? ['empty'] : [''];
                                        }

                                        const exclusiveCheckboxes = ['IsDriverCost', 'IsFuelPurchase', 'IsTolls', 'IsWorkOrders', 'IsOther'];
                                        if (exclusiveCheckboxes.includes(name) && value === true) {
                                            let updatedFields = fields;
                                            exclusiveCheckboxes.forEach(field => {
                                                if (field !== name) {
                                                    updatedFields = FieldsManager.updateField(updatedFields, field, false);
                                                }
                                            });
                                            updatedFields['IsOther'].validate = [''];
                                            fields['IsOther'].metadata.htmlBefore = null;
                                            return FieldsManager.updateField(updatedFields, name, value);
                                        }

                                        // Check if none are selected after this change
                                        const noneChecked = exclusiveCheckboxes
                                            .filter(field => field !== name)
                                            .every(field => !fields[field]?.value) && value !== true;

                                        if (exclusiveCheckboxes.includes(name) && noneChecked) {
                                            fields['IsOther'].validate = ['empty'];
                                            fields['IsOther'].metadata.htmlBefore = () => {return <div className={"col-span-full text-red-600"}>If none of above is selected, please select Recurring</div>}
                                        } else if (exclusiveCheckboxes.includes(name)) {
                                            fields['IsOther'].validate = [''];
                                        }

                                        return FieldsManager.updateField(fields, name, value)
                                    }}
                                    fields={(item) => {
                                        return {
                                            TruckCostCategoryID: new Field('TruckCostCategoryID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
                                            Amount: new Field('Amount', '', ['empty'], false, 'money', {addContainerClass: 'col-span-full'}),
                                            ProfitabilityType: new Field('ProfitabilityType', '1', ['empty'], false, 'radio', {
                                                options: [
                                                    {name: 'Fixed amount (per period)', value: '1'},
                                                    {name: 'Per total mile', value: '2'}
                                                ],
                                                addContainerClass: 'grid col-span-3',
                                                render: (it) => {
                                                    let text = '';
                                                    switch (+it.ProfitabilityType) {
                                                        case 1:
                                                            text = 'Fixed amount (per period)'
                                                            break;
                                                        case 2:
                                                            text = 'Per total mile'
                                                            break;
                                                    }
                                                    return text
                                                }
                                            }),
                                            Frequency: new Field('Frequency', '', item?.ProfitabilityType === 2 ? [''] : ['empty'], false, item?.ProfitabilityType === 2 ? 'hidden' : 'select', {addContainerClass: 'col-span-full'}, {
                                                values: {1: "Daily", 2: "Weekly", 3: "Monthly", 4:"Annually"},
                                                valueSort: true
                                            }),
                                            StartDate: new Field('StartDate', '', ['empty'], false, 'date', {addContainerClass: 'col-span-full'}, { isClearable: true }),
                                            EndDate: new Field('EndDate', '', [''], false, 'date', {addContainerClass: 'col-span-full', htmlAfterField: () => {
                                                    return <div className={"absolute mt-12 mb-2 text-[14px] font-semibold"}>If no end date is selected, this cost will continue indefinitely</div>
                                                },labelRaw: "End date (optional)"}, { isClearable: true }),
                                            Notes: new Field('Notes', '', [''], false, 'textarea', {label:"Description",labelRaw:"Description (optional)", addContainerClass: 'mt-6 col-span-full', htmlAfter: () => {
                                                    return <div className={"col-span-3"}>
                                                        <p className={"font-bold my-1"}>Report Column Mapping</p>
                                                        <div className="relative bottom-5 right-5">
                                                            <Tooltip content={
                                                                <div>
                                                                    <div className="flex gap-2 mb-2">
                                                                        <InformationCircleIcon
                                                                            className="text-blue-400 w-5 h-5 text-primary-600 shrink-0 mt-0.5"/>
                                                                        <p className="text-sm font-semibold text-tm-gray-900">Report Column
                                                                            Mapping</p>
                                                                    </div>
                                                                    <p className="text-sm text-tm-gray-600">
                                                                        controls where this manual cost appears in profitability reports.
                                                                        Connected columns can later be turned on or off from report filters
                                                                        to
                                                                        compare manual setup costs against actual system costs.
                                                                    </p>
                                                                </div>
                                                            }
                                                                     theme={"light"}
                                                            >
                                                                <div dir="rtl" className={"w-6 h-6 relative left-full"}><InformationCircleIcon className="text-blue-400 w-6 h-6"/></div>
                                                            </Tooltip>
                                                        </div>

                                                        <div className={"space-y-2"}>
                                                            <p>This cost must be connected to at least one report column. Recurring Cost is
                                                                selected by default.</p>
                                                            <p>You can keep this cost only under Recurring Cost, or you can also connect it
                                                                to other report columns such as Driver Cost, Fuel Purchase, Toll, or Work
                                                                Order.</p>
                                                            <p>Only connected columns will be available later in profitability report
                                                                filters for manual setup comparison.</p>
                                                            <div className={"grid col-span-3 my-2"}>
                                                                <InfoParagraph type="info">
                                                                    <div>
                                                                        <div>
                                                                            <p>Recurring Cost is selected by default. You can also connect
                                                                                this cost to other report columns. At least one column must
                                                                                be selected.</p>
                                                                        </div>
                                                                    </div>
                                                                </InfoParagraph>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            }),
                                            IsDriverCost: new Field('IsDriverCost', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full', htmlAfterField: () => {
                                                    return <div className={"flex w-72"}>Connect this cost to the Driver Cost column in profitability reports.</div>
                                                }}),
                                            IsFuelPurchase: new Field('IsFuelPurchase', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full', htmlAfterField: () => {
                                                    return <div className={"flex w-72"}>Connect this cost to the Fuel Purchase column in profitability reports.</div>
                                                }}),
                                            IsTolls: new Field('IsTolls', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full', htmlAfterField: () => {
                                                    return <div className={"flex w-72"}>Connect this cost to the Toll column in profitability reports.</div>
                                                }}),
                                            IsWorkOrders: new Field('IsWorkOrders', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full', htmlAfterField: () => {
                                                    return <div className={"flex w-72"}>Connect this cost to the Maintenance / Work Order Cost column in profitability reports.</div>
                                                }}),
                                            IsOther: new Field('IsOther', '1', [''], false, 'checkbox', {
                                                addContainerClass: 'col-span-full',
                                                label: "Recurring",
                                                htmlAfterField: () => {
                                                    return <div className={"flex w-72"}>Connect this cost to the Recurring Cost column in profitability reports.</div>
                                                },
                                                htmlAfter: () => {
                                                    return (<div className="col-span-3"><InfoParagraph type="warning">
                                                        <div>
                                                            <div>
                                                                <p>At least one report column must be selected</p>
                                                            </div>
                                                        </div>
                                                    </InfoParagraph>
                                                    </div>)
                                                }
                                            }),
                                            IsActive: new Field('IsActive', '1', [''], false, 'checkbox', {addContainerClass: 'col-span-full',
                                                htmlAfterField: () => {
                                                    return <div className={"flex w-72"}>When active, this cost is included based on the selected dates and settings. If inactive, the cost is saved but not used in reports.</div>
                                                }})
                                        }
                                    }}
                                    searchFields={{
                                        query: new Field('query', '', [''], false, 'search', {}),
                                        limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true})
                                    }}
                                />

                                </div>)
                            }

                            {this.state.selectedProfitabilityTab === 'Adjustments' &&
                                (<ResourceListTab
                                    tabKey={'TruckProfitAdjustments'}
                                    id={this.getID()}
                                    dispatch={this.props.dispatch}
                                    translate={this.props.translate}
                                    resource={this.props.resource}
                                    dialogTitle={translate("dialog.title.TruckCostAdjustments")}
                                    hideTitle={true}
                                    buttonLabel={"Add adjustment"}
                                    handleInputChange={(fields, name, value) => {
                                        const exclusiveCheckboxes = ['IsDriverCost', 'IsFuelPurchase', 'IsTolls', 'IsWorkOrders', 'IsOther'];
                                        if (exclusiveCheckboxes.includes(name) && value === true) {
                                            let updatedFields = fields;
                                            exclusiveCheckboxes.forEach(field => {
                                                if (field !== name) {
                                                    updatedFields = FieldsManager.updateField(updatedFields, field, false);
                                                }
                                            });
                                            updatedFields['IsOther'].validate = [''];
                                            fields['IsOther'].metadata.htmlBefore = null;
                                            return FieldsManager.updateField(updatedFields, name, value);
                                        }

                                        // Check if none are selected after this change
                                        const noneChecked = exclusiveCheckboxes
                                            .filter(field => field !== name)
                                            .every(field => !fields[field]?.value) && value !== true;

                                        if (exclusiveCheckboxes.includes(name) && noneChecked) {
                                            fields['IsOther'].validate = ['empty'];
                                            fields['IsOther'].metadata.htmlBefore = () => {return <div className={"col-span-full text-red-600"}>If none of above is selected, please select Adjustment</div>}
                                        } else if (exclusiveCheckboxes.includes(name)) {
                                            fields['IsOther'].validate = [''];
                                        }

                                        return FieldsManager.updateField(fields, name, value)
                                    }}

                                    sortBy={'TruckProfitAdjustmentsID'}
                                    primaryKey={'TruckProfitAdjustmentsID'}
                                    resourceName={Resources.TruckProfitabilityAdjustments}
                                    fields={() => {return {
                                        DateRange: new Field('DateRange', '', [''], false, 'custom', {
                                            render:(it) => {
                                                const formatDate = (dateStr) => {
                                                    const date = new Date(dateStr);
                                                    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
                                                };

                                                return (<div>{formatDate(it.StartDate)} - {formatDate(it.EndDate)}</div>)
                                            },
                                            addContainerClass: 'col-span-full'}),
                                        TruckCostCategoryID: new Field('TruckCostCategoryID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-full'}),
                                        Amount: new Field('Amount', '', ['empty'], false, 'money', {addContainerClass: 'col-span-full', label: "Adjustment_amount", labelRaw: "Adjustment amount (Enter only the difference)", htmlAfter: (item) => {
                                            const num = parseFloat(item.value);
                                            return <div className={"col-span-3"}><p className="text-md mt-1">
                                                Enter only the difference (e.g., +200 to increase cost, -150 to decrease).
                                            </p>

                                                {!!num && (
                                                    <div className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium border mt-2
                                                ${num < 0
                                                        ? "bg-red-50 border-red-200 text-red-600"
                                                        : "bg-green-50 border-green-200 text-green-600"
                                                    }`}
                                                    >
                                                        <span>{num < 0 ? "▼" : "▲"}</span>
                                                        <span>
                                                      {num < 0
                                                          ? `-$${Math.abs(num).toFixed(2)} will reduce total cost`
                                                          : `+$${num.toFixed(2)} will increase total cost`}
                                                    </span>
                                                    </div>
                                                )}</div>}}, {  isNegativeAllowed: true}),
                                        ApplyAs: new Field('ApplyAs', '1', ['empty'], false, 'radio', {
                                            options: [
                                                {name: 'Evenly Across Days', value: '1'},
                                                {name: 'Based on Miles in period - (Allocate based on miles driven in the selected range)', value: '2'}
                                            ],
                                            addContainerClass: 'grid col-span-3',
                                            render: (it) => {
                                                let text = '';
                                                switch (+it.ApplyAs) {
                                                    case 1:
                                                        text = 'Evenly Across Days'
                                                        break;
                                                    case 2:
                                                        text = 'Based on Miles in period'
                                                        break;
                                                }
                                                return text
                                            }
                                        }),
                                        StartDate: new Field('StartDate', '', ['empty'], false, 'date', {addContainerClass: 'col-span-full'}),
                                        EndDate: new Field('EndDate', '', ['empty'], false, 'date', {addContainerClass: 'col-span-full'}),
                                        Description: new Field('Description', '', [''], false, 'textarea', {label:"Description",labelRaw:"Description (optional)", addContainerClass: 'mt-6 col-span-full'}),
                                        IsDriverCost: new Field('IsDriverCost', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full'}),
                                        IsFuelPurchase: new Field('IsFuelPurchase', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full'}),
                                        IsTolls: new Field('IsTolls', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full'}),
                                        IsWorkOrders: new Field('IsWorkOrders', false, [''], false, 'checkbox', {addContainerClass: 'col-span-full'}),
                                        IsOther: new Field('IsOther', '1', [''], false, 'checkbox', {addContainerClass: 'col-span-full', label:"Adjustment"}),
                                        IsActive: new Field('IsActive', '1', [''], false, 'checkbox', {addContainerClass: 'col-span-full'})
                                    }}}
                                    searchFields={{
                                        query: new Field('query', '', [''], false, 'search', {}),
                                        limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true})
                                    }}
                                />)
                            }
                        </>
                    )}

                    {this.state.selectedTab === Resources.TrucksLocations && (
                        <LocationsTab
                            {...this.props}
                            resourcePath={Resources.TrucksLocations}
                            primaryKey={'TruckLocationID'}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrucksLoads && (
                        <LoadsTab
                            tabResource={Resources.TrucksLoads}
                            handleTabChange={this.handleTabChange}
                            id={this.getID()}
                            tabKey={'id'}
                            resource={this.props.resource}
                            dispatch={this.props.dispatch}
                            history={this.props.history}
                            translate={this.props.translate}
                        />
                    )}

                    {this.state.selectedTab === Resources.TruckServices && (
                        <ServicesTab
                            {...this.props}
                            tabKey={'TruckServices'}
                            disableEdit={!checkPerm(Resources.TruckServices, UPDATE_PERM)}
                            disableDelete={!checkPerm(Resources.TruckServices, DELETE_PERM)}
                            dialogTitle={translate("title.service")}
                            // hideTitle={true}

                            sortBy={'TruckServiceID'}
                            primaryKey={'TruckServiceID'}
                            resourceName={Resources.TruckServices}
                            TruckID={this.getID()}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrucksExpiry && (
                        <ExpiryItemsTab
                            translate={translate}
                            resourceName={Resources.TrucksExpiry}
                            Reference={getProp(infoData, 'TruckNumber', '')}
                            ReferenceID={this.getID()}
                            ReferenceType={REFERENCE_TYPE_TRUCK}
                        />
                    )}

                    <ModalConfirm
                        type="default"
                        title={translate("dialog_heading.unsaved_changes_on_tab")}
                        show={!!this.state.confirmModalOpen}
                        onClose={() => this.setState({confirmModalOpen: false})}
                        buttonLabel={translate("btn.proceed")}
                        closeButtonLabel={translate('btn.stay_on_current_tab')}
                        translate={translate}
                        onConfirm={() => this.setState({
                            selectedTab: this.state.reserveTab,
                            confirmModalOpen: false,
                            canSwapTabs: true,
                            tabs: this.state.tabs.map((it) => {
                                it.current = it.resource === this.state.reserveTab
                                return it
                            })
                        })}
                    >
                        <p>{translate("text.unsaved_changes_on_tab")}</p>
                        <p>{translate("text.unsaved_changes_on_tab_line_2")}</p>
                    </ModalConfirm>

                    <ModalDefault
                        show={!!this.state.resourceTaskModalOpen}
                        widthClass={'max-w-3xl'}
                        title={translate('text.truck_tasks')}

                        closeButtonLabel={translate('btn.close')}
                        onClose={this.handleToggleResourceTasks}

                        translate={translate}
                    >
                        <ResourceTasksDialog
                            close={this.hideConfirmCheckLoadTasksHandler}
                            {...this.props}
                            large={true}
                        />
                    </ModalDefault>

                    <ModalSaveResource
                        title={"Apply template"}
                        widthClass="max-w-md"
                        gridColsClass="grid-cols-3"
                        show={this.state.applyTemplateOpen}
                        onClose={this.handleToggleApplyTemplateModal}
                        fields={this.getApplyFields()}
                        onSubmit={(params) => {
                            if (params) {
                                this.props.dispatch(createResource({
                                    user: LocalStorage.get("user"),
                                    params: params,
                                    query: {id: this.getID()},
                                    resource: Resources.TruckProfitabilityTemplateApply,
                                    piggyResource: Resources.TruckProfitability,
                                    errorMessage: true, successMessage: "Template applied",
                                }));
                                this.handleToggleApplyTemplateModal()
                            }
                        }}
                        metadata={{
                            TruckProfitTemplateID: {
                                api: 'api/' + Resources.TruckProfitabilityTemplate,
                                query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                                searchMap: (item) => ({
                                    value: item.TruckProfitTemplateID,
                                    label: item.TruckProfitTemplate
                                })}
                        }}
                        translate={this.props.translate}
                    />
                </Page>
            </Layout>
        )
    }
}

export default connect(state => state)(TruckView)
